'use client';

import { useEffect, useState } from 'react';

type BannerImageProps = {
  src: string;
  className?: string;
  fallbackAspectRatio?: string;
  onError?: () => void;
};

const BannerImage = ({ src, className = '', fallbackAspectRatio, onError }: BannerImageProps) => {
  const [aspectRatio, setAspectRatio] = useState<string | undefined>(fallbackAspectRatio);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      if (img.naturalWidth && img.naturalHeight) {
        setAspectRatio(`${img.naturalWidth} / ${img.naturalHeight}`);
      }
    };
    img.onerror = () => {
      onError?.();
    };
    img.src = src;
  }, [src]);

  return (
    <div
      className={className}
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        ...(aspectRatio ? { aspectRatio } : {}),
      }}
      role="presentation"
    />
  );
};

export default BannerImage;
